import { css } from '@emotion/react';

export const StyledGlobal = css`
  * {
    user-select: none;
    ::-webkit-scrollbar
   {
       width:4px;
       height:4px;
       background-color:transparent;
   }
 
   /*定义滑块
    内阴影+圆角*/
	 /*  鼠标hover的时候才显示滚动条 */
   :hover::-webkit-scrollbar-thumb
   {
       border-radius:4px;
       -webkit-box-shadow:inset 0 0 6px rgb(0 0 0 / 20%);
       background: #4E535A;
       -webkit-transition: 0.3s;
       transition: 0.3s;
       margin-left:5px;
   }
    /* ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    ::-webkit-scrollbar-button {
      width: 4px;
      height: 0;
    }

    ::-webkit-scrollbar-track {
      background: 0 0;
    }

    ::-webkit-scrollbar-thumb {
      background: #4E535A;
      -webkit-transition: 0.3s;
      transition: 0.3s;
      border-radius: 4px;
      margin-left:5px;
    } */
  }

  html,
  body {
    padding: 0;
    margin: 0;
    font-family: 'Microsoft YaHei', 'Microsoft YaHei UI', '微软雅黑', 'Hiragino Sans GB', 'Hiragino Sans GB W3', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      Helvetica, Arial, sans-serif;
  }
  html,
  body,
  #root {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 16px;
  }
`;
